var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"extensions"},[_c('p',[_vm._v("Extension "+_vm._s(_vm.src)+" En llamada con "+_vm._s(_vm.dst))])]),_c('Chronometer',{staticClass:"chronometer",attrs:{"timestamp":_vm.startedAt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }